export const translationUploadData_da_part1 = {
  expirationPicker: "Dato og Tid",
  errorFetchingIndexes: "Fejl ved hentning af indeks. Prøv igen.",
  errorFetchingData: "Fejl ved hentning af data. Prøv igen.",
  errorConversations: "Fejl ved hentning af samtaler. Prøv igen.",
  tokenChatbotMissing: "Token eller chatbotID ikke fundet",
  convoResolved: "Samtale markeret som løst.",
  errorUpdatingConvo: "Fejl ved opdatering af samtale.",
  titleRequired: "Titel er påkrævet.",
  titleLimit: "Titlen må ikke overstige 50 tegn.",
  tokenNotFound: "Token ikke fundet.",
  errorUpdatingData: "Fejl ved opdatering af data.",
  dataUpdated: "Data updated in",
  dataAdded: "Data added to",
  errorUpdating: "Error updating data in",
  errorAdding: "Error adding data to",
  dataDeletedFrom: "Data deleted from",
  errorDeletingFrom: "Error deleting data from",
  dataUploaded: "Data uploaded to",
  errorUploadingTo: "Error uploading to",
  convoMarkedResolved: ". Samtale markeret som løst.",
  myInfoChunks: "Mine info chunks",
  lackingInfoConvos: "Samtaler med Manglende Info",
  conversationDetails: "Samtale Detaljer",
  uploadDataHeader: "Upload og Håndter Information",
  addNew: "Tilføj ny",
  addNewInfo: "Tilføj ny info",
  noConversationSelected: "Ingen samtale valgt.",
  deleteLabel: "Slet",
  conversationID: "Samtale ID",
  dateLabel: "Dato",
  topicLabel: "Emne",
  uncategorized: "Ikke kategoriseret",
  requiredTitlePlaceholder: "Indtast en titel for din information",
  uploadInfoPlaceholder: "Indtast information du vil uploade",
  uploadFormattingToolbar: "Tekstformatering",
  uploadFormattingBold: "Fed",
  uploadFormattingItalic: "Kursiv",
  uploadFormattingHint: "Brug knapperne til fed eller kursiv tekst.",
  chunkOverridesSection: "Chatbot-tilpasninger",
  chunkOverridesHint:
    "Markér en del af teksten og klik Tilføj tilpasning — vælg derefter hvilke chatbots der skal have deres egen version af den del. Tilpassede dele fremhæves: hold musen over for at se, klik for at redigere. Tilpasningen gælder kun chatbots, der bruger denne vidensbase.",
  overridesAdd: "Tilføj tilpasning",
  overridesEditorIntro: "Vælg de chatbots, der skal sige noget andet her.",
  overridesRemove: "Fjern",
  overridesEmptyHint: "Ingen tilpasninger — alle chatbots bruger den fælles tekst.",
  overridesTextPlaceholder: "Version af indholdet for denne chatbot",
  overridesSelectionMissing: "Markér først den del af teksten, du vil tilpasse.",
  overridesOriginalLabel: "Original",
  overridesOverrideLabel: "Erstatning for denne chatbot",
  overridesStaleWarning:
    "Den originale tekst findes ikke længere i den fælles version — tilpasningen er inaktiv.",
  overridesEntireTextLabel: "Hele teksten erstattes for denne chatbot",
  overridesPreviewLabel: "Vis teksten denne chatbot vil bruge",
  overridesDone: "Færdig",
  overridesSearchChatbots: "Søg chatbots",
  overridesNoChatbotMatches: "Ingen chatbots matcher søgningen.",
  overridesAddAllChatbots: "Tilføj alle",
  overridesCountHint: "Chatbots med deres egen version af denne del / chatbots der kan få en",
  chatbot: "Chatbot",
  fileUploadChooseFile: "Vælg fil",
  updating: "Opdaterer...",
  uploading: "Uploader...",
  update: "Opdater",
  upload: "Upload",
  cancel: "Annuller",
  removing: "Markerer...",
  remove: "Fjern",
  addNotesHere: "Tilføj noter her...",
  dataDeletedMessage: "Data deleted from",
  errorDeletingMessage: "Error deleting data from",
  deleteFromAll: "Slet fra alle videnbaser",
  confirmDeleteAll: "Er du sikker på at du vil slette fra alle videnbaser?",
  deletedFromAll: "Slettet fra alle videnbaser",
  expiresAt: "Udløber",
  sortByLabel: "Sortér efter:",
  sortByDateNewest: "Dato (Nyeste først)",
  sortByTitleAZ: "Titel (A-Å)",
  typeYourAnswer: "Skriv dit svar her...",
  searchInfoChunks: "Søg i dine info chunks...",
  selectOption: "Vælg mulighed",
  selectKnowledgebase: "Vælg vidensdatabase",
  selectKnowledgebaseTooltip:
    "Vælg hvilken vidensdatabase indholdet skal gemmes i - fx produkter til produktinfo og generelt til generel info. Hvis du er i tvivl, så tilføj begge.",
  companyInfo: "Virksomhedsinformation",
  livechat: "Livechat",
  optional: "Valgfri",
  expirationDate: "Udløbsdato",
  expirationDateTooltip:
    "Indstil en udløbsdato for automatisk at fjerne dette indhold fra systemet på det angivne tidspunkt.",
  deadlineOptional: "Deadline (valgfri)",
  scheduleUpload: "Planlæg Upload",
  scheduleTime: "Planlagt tidspunkt",
  selectScheduleTime: "Vælg tidspunkt for upload",
  scheduleDateTime: "Dato og tidspunkt",
  immediateUpload: "Upload nu",
  scheduledUpload: "Planlagt upload",
  scheduleRequired: "Planlagt tidspunkt er påkrævet",
  scheduleTimeInPast: "Planlagt tidspunkt skal være i fremtiden",
  scheduledFor: "Planlagt til",
  chunkDisabled: "Deaktiveret",
  chunkPartiallyDisabled: "Delvist deaktiveret",
  chunkEnable: "Aktiver chunk",
  chunkDisable: "Deaktiver chunk",
  chunkEnabledLabel: "Aktiv i vidensbasen",
  chunkEnabledHint: "Deaktiverede chunks forbliver i listen, men hentes ikke af bots.",
  chunkEnabledMessage: "Chunk aktiveret",
  chunkDisabledMessage: "Chunk deaktiveret",
  chunkStatusUpdateError: "Kunne ikke opdatere chunk-status",
  chunkScheduleSection: "Synlighedsplan",
  chunkScheduleHint:
    "Valgfri plan for hvornår chunk'en skal være aktiv i vidensbasen (fx 17:00–07:00).",
  chunkSchedulePill: "Planlagt synlighed",
  chunkScheduleNone: "Altid aktiv",
  chunkScheduleFixed: "Mellem datoer",
  chunkScheduleWeekly: "Ugentlige timer",
  bannerScheduleNone: "Altid (ingen plan)",
  bannerScheduleFixed: "Mellem datoer",
  bannerScheduleWeekly: "Ugentlige timer",
  bannerScheduleStarts: "Start (valgfri)",
  bannerScheduleEnds: "Slut (valgfri)",
  bannerScheduleTz: "Tidszone",
  bannerScheduleWeeklyDays: "Dage",
  bannerScheduleWeeklyStart: "Starttid",
  bannerScheduleWeeklyEnd: "Sluttid",
};
